/** Alte Lesezeichen auf `#/lebensrad` fuehren in die Monatsreflexion (V-07). */
import { Navigate } from 'react-router-dom';

import { monatKey } from '@/domain/review/periods';
import { today } from '@/lib/datetime';

export function ZumLebensrad() {
  return <Navigate to={`/rueckblick?monat=${monatKey(today())}`} replace />;
}
